export const Angular_Motion = {
    value: 'Angular Motion',
    label: 'Angular Motion',
    id: 'Angular Motion',
    image: '/images/MinLiveLength/angNotes.GIF',
    image2: '/images/MinLiveLength/angMain.GIF',
    image3: '/images/MinLiveLength/motion_angular_update.png',
    inputformat: 'Deflection Ø ( ° )',
    outputformat: '',
    motiondesc: 'occurs when one end of a hose assembly is deflected in a simple bend with the ends not remaining parallel.',
    motionname: 'Angular Motion',
};
export const Offset_Free_End = {
    value: 'Offset (End is free to move "out of line")',
    label: 'Offset (End is free to move "out of line")',
    id: 'Offset (End is free to move "out of line")',
    image: '/images/MinLiveLength/offNotes.GIF',
    image2: '/images/MinLiveLength/freeOff.GIF',
    image3: '/images/MinLiveLength/motion_offset[2].png',
    inputformat: 'Offset to one side - T (in.)',
    outputformat: 'Projected Length-Lp(in.)',
    motiondesc: 'occurs when one end of the hose assembly is deflected in a plane perpendicular to the longitudinal axis with the ends remaining parallel. This movement can be due to a one-time (static) bend or to movement which repeatedly occurs over time (such as thermal expansion). When the offset motion occurs to both sides of the hose centerline, use Total Travel for the input; i.e., 2T.',
    motionname: 'Offset Motion',
};
export const Offset_Restricted = {
    value: 'Offset (Move is restricted to up and down)',
    label: 'Offset (Move is restricted to up and down)',
    id: 'Offset (Move is restricted to up and down)',
    image: '/images/MinLiveLength/offNotes.GIF',
    image2: '/images/MinLiveLength/restOff.GIF',
    image3: '/images/MinLiveLength/motion_offset_crowded[2].png',
    inputformat: 'Offset to one side - T (in.)',
    outputformat: 'Projected Length-Lp(in.)',
    motiondesc: 'occurs when one end of the hose assembly is deflected in a plane perpendicular to the longitudinal axis with the ends remaining parallel. This movement can be due to a one-time (static) bend or to movement which repeatedly occurs over time (such as thermal expansion). When the offset motion occurs to both sides of the hose centerline, use Total Travel for the input; i.e., 2T.',
    motionname: 'Offset Motion',
};
export const Traveling_Loop_Constant = {
    value: 'Traveling Loop (Constant Radius)',
    label: 'Traveling Loop (Constant Radius)',
    id: 'Traveling Loop (Constant Radius)',
    image: '/images/MinLiveLength/loopConNotes.GIF',
    image2: '/images/MinLiveLength/loopCon.GIF',
    image3: '/images/MinLiveLength/travelloop_constant[2].png',
    inputformat: 'Total Travel T, (in.)',
    outputformat: 'Loop Hang Length-H1(in.)',
    motiondesc: 'configuration offers an ideal solution when axial movement must be absorbed or when magnitude of the motion is in excess of the limits of an offset movement. A Constant Radius loop accommodates motion by varying the length of the arms of the assembly while the radius remains constant.',
    motionname: 'Traveling Loops',
};
export const Traveling_Loop_Variable = {
    value: 'Traveling Loop (Variable Radius)',
    label: 'Traveling Loop (Variable Radius)',
    id: 'Traveling Loop (Variable Radius)',
    image: '/images/MinLiveLength/loopVarNotes.GIF',
    image2: '/images/MinLiveLength/loopVar.GIF',
    image3: '/images/MinLiveLength/travelloop_variable[2].png',
    inputformat: 'Total Travel T, (in.)',
    outputformat: 'Loop Hang Length-H1(in.)',
    motiondesc: 'configuration offers an ideal solution when axial movement must be absorbed or when magnitude of the motion is in excess of the limits of an offset movement. A Variable Radius loop accommodates motion by varying the Bend Radius of the hose assembly.',
    motionname: 'Traveling Loops',
};
export const Traveling_Loop_Movement = {
    value: 'Traveling Loop (Movement in Two Directions)',
    label: 'Traveling Loop (Movement in Two Directions)',
    id: 'Traveling Loop (Movement in Two Directions)',
    image: '/images/MinLiveLength/loopTwoNotes.GIF',
    image2: '/images/MinLiveLength/loopTwo.gif',
    image3: '/images/MinLiveLength/travelloop_2directions[2].png',
    inputformat: 'Travel-T2 (in.)',
    outputformat: 'Loop Hang Length-H1(in.)',
    motiondesc: 'configuration offers an ideal solution when axial movement must be absorbed or when magnitude of the motion is in excess of the limits of an offset movement. Loop with movements in two directions accommodates motion by varying the Bend Radius of the hose assembly.',
    motionname: 'Traveling Loops',
};


export const Motions = [
    Angular_Motion,
    Offset_Free_End,
    Offset_Restricted,
    Traveling_Loop_Constant,
    Traveling_Loop_Variable,
    Traveling_Loop_Movement

];
